var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconResumeDoneGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3334 7H11.6667C10.378 7 9.33337 8.04467 9.33337 9.33333V46.6667C9.33337 47.9553 10.378 49 11.6667 49H44.3334C45.622 49 46.6667 47.9553 46.6667 46.6667V9.33333C46.6667 8.04467 45.622 7 44.3334 7Z",
    fill: "#15C480"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1876 35.2916C38.0735 35.2916 38.7917 34.5734 38.7917 33.6874C38.7917 32.8015 38.0735 32.0833 37.1876 32.0833H18.8126C17.9266 32.0833 17.2084 32.8015 17.2084 33.6874C17.2084 34.5734 17.9266 35.2916 18.8126 35.2916H37.1876Z",
    fill: "#9EEED3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1876 42.0001C38.0735 42.0001 38.7917 41.2819 38.7917 40.3959C38.7917 39.51 38.0735 38.7917 37.1876 38.7917H18.8126C17.9266 38.7917 17.2084 39.51 17.2084 40.3959C17.2084 41.2819 17.9266 42.0001 18.8126 42.0001H37.1876Z",
    fill: "#9EEED3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0024 19.915C29.6358 19.915 30.9599 18.5909 30.9599 16.9575C30.9599 15.3241 29.6358 14 28.0024 14C26.369 14 25.0449 15.3241 25.0449 16.9575C25.0449 18.5909 26.369 19.915 28.0024 19.915Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2299 26.2507H23.7715C23.5736 26.2524 23.3781 26.2081 23.2002 26.1214C23.0223 26.0347 22.8669 25.908 22.7462 25.7511C22.6255 25.5943 22.5428 25.4116 22.5047 25.2174C22.4665 25.0232 22.4738 24.8229 22.5261 24.632C23.2174 22.2637 25.4049 20.6741 28.0007 20.6741C30.5965 20.6741 32.784 22.2637 33.4753 24.632C33.5276 24.8229 33.5349 25.0232 33.4967 25.2174C33.4585 25.4116 33.3759 25.5943 33.2552 25.7511C33.1345 25.908 32.9791 26.0347 32.8012 26.1214C32.6233 26.2081 32.4277 26.2524 32.2299 26.2507Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0417 54.8333C50.0017 54.8333 54.8333 50.0017 54.8333 44.0417C54.8333 38.0816 50.0017 33.25 44.0417 33.25C38.0816 33.25 33.25 38.0816 33.25 44.0417C33.25 50.0017 38.0816 54.8333 44.0417 54.8333Z",
    fill: "#FFC82A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4217 48.0666L49.5882 42.1233C50.1694 41.4546 50.0986 40.4414 49.4299 39.8602C48.7613 39.2789 47.7481 39.3498 47.1668 40.0184L42.0004 45.9618C41.4191 46.6304 41.49 47.6436 42.1586 48.2249C42.8273 48.8061 43.8405 48.7353 44.4217 48.0666Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3455 45.8787L40.8394 42.3726C40.2129 41.7461 39.1972 41.7461 38.5708 42.3726C37.9443 42.9991 37.9443 44.0148 38.5708 44.6412L42.0768 48.1473C42.7033 48.7738 43.719 48.7738 44.3455 48.1473C44.9719 47.5208 44.9719 46.5051 44.3455 45.8787Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResumeDoneGreen);
export default __webpack_public_path__ + "static/media/icon_resume_done_green.a6b0b7ac.svg";
export { ForwardRef as ReactComponent };